import { SingleLine } from "./SingleLine.js";
export class LinePointToPoint extends SingleLine {
    constructor(name, color, v1, v2) {
        super(name, color);
        this.isLinePointToPoint = true;
        this.updatePosition = () => {
            this._v1 && this._v2 && this.setAB(this._v1.position, this._v2.position);
        };
        this.name = name;
        this.interceptedByRaycaster = false;
        if (v1) {
            this._v1 = v1;
        }
        if (v2) {
            this._v2 = v2;
        }
        this.updatePosition();
        this.bindEvents();
    }
    set v1(value) {
        this._v1?.unbindEvent("onPositionComponentChange", this.updatePosition);
        this._v1 = value;
        this._v1?.bindEvent("onPositionComponentChange", this.updatePosition);
        this.updatePosition();
    }
    set v2(value) {
        this._v2?.unbindEvent("onPositionComponentChange", this.updatePosition);
        this._v2 = value;
        this._v2?.bindEvent("onPositionComponentChange", this.updatePosition);
        this.updatePosition();
    }
    bindEvents() {
        this._v1?.bindEvent("onPositionComponentChange", this.updatePosition);
        this._v2?.bindEvent("onPositionComponentChange", this.updatePosition);
    }
    dispose() {
        super.dispose();
        this._v1?.unbindEvent("onPositionComponentChange", this.updatePosition);
        this._v2?.unbindEvent("onPositionComponentChange", this.updatePosition);
    }
}
//# sourceMappingURL=LinePointToPoint.js.map